import Image from 'next/image';
import styles from './cta-banner.module.scss';
import { techDueDiligenceState } from '../../tech-due-diligence.state';
import { CALENDLY_BOOKING_URL } from '@components/shared/forms/tech-due-diligence-form/form.config';
import { ButtonHandshkaeGreen } from '@components/shared/buttons/button-handshake-green';

const CtaBanner = () => {
  const { title, description, btnText, imageUrl } = techDueDiligenceState.ctaBanner;

  return (
    <section className={styles.section}>
      <div className={styles.section__wrapper}>
        <div className={styles.section__content}>
          <h2 className={styles.section__title}>{title}</h2>
          <p className={styles.section__text}>{description}</p>
          <ButtonHandshkaeGreen
            text={btnText}
            action={() => window.open(CALENDLY_BOOKING_URL, '_blank', 'noopener,noreferrer')}
            className="white"
          />
        </div>
        <div className={styles.section__image}>
          <Image src={imageUrl} alt={title} layout={'fill'} objectFit={'contain'} />
        </div>
      </div>
    </section>
  );
};

export default CtaBanner;
